export var PRESCHOOL = 'PRESCHOOL';
export var COMPULSORY_SCHOOL = 'COMPULSORY_SCHOOL';
export var UPPER_SECONDARY_EDUCATION = 'UPPER_SECONDARY_EDUCATION';
export var ADULT_EDUCATION = 'ADULT_EDUCATION';